/** World identity comes from the route, never a persisted preference or login token. */
export const MAIN_WORLD = window.location.pathname.startsWith('/main/');
export const WORLD_ID = MAIN_WORLD ? 'main' : 'legacy';
export const WORLD_NAME = MAIN_WORLD ? 'Monument' : 'Legacy';
export const WORLD_DB = MAIN_WORLD ? 'eoweb-main-db' : 'db';
export function worldStorageKey(key: string): string {
  return MAIN_WORLD ? `world:main:${key}` : key;
}
export function worldResource(path: string): string {
  return MAIN_WORLD && path.startsWith('/') && !path.startsWith('//') ? `/main${path}` : path;
}
export function worldSocket(): string {
  return `${location.protocol === 'https:' ? 'wss:' : 'ws:'}//${location.host}${MAIN_WORLD ? '/main' : ''}/ws`;
}
